module.exports = __webpack_public_path__ + "img/space_dust_grape_box.d179ad27.png";